import type { Dayjs } from 'dayjs';
import dayjs from 'dayjs';

type Options = {
  format: string;
};

export default function dayjsFormat(
  date: Dayjs | undefined,
  options: Options,
): string {
  const { format } = options;

  return dayjs(date).format(format);
}
